export default __webpack_public_path__ + "img/leaderboard.361225e7.png";